import register from '../../../../global/js/registry';
export default register('o-shopping-cart', () => import(/* webpackMode: "lazy" */ './o-shopping-cart.controller'));
